// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!@css/utils");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, "._6LLM31vGx{align-items:center;display:flex;flex-direction:column;margin-bottom:-3px;text-align:center}._2hlz5Hwbx{display:inline-flex;border:0;height:3px;overflow:hidden;width:100%}._70QyLkzWx{}._336fLpQhx,._336fLpQhx::after{cursor:default}.X9ZXzDi5x{transition:width 100ms ease-out}._79GwA8NBx{background-color:#006fc8}@media screen and (-ms-high-contrast: active){._79GwA8NBx{background-color:highlight}}@-webkit-keyframes _7ahjos0Ux{from{left:-30%}to{left:100%}}@keyframes _7ahjos0Ux{from{left:-30%}to{left:100%}}._7CX1GNnmx{background-color:#006fc8;color:var(--secondary-text)}._7CX1GNnmx::after{-webkit-animation:_7ahjos0Ux 1.5s ease-out infinite;animation:_7ahjos0Ux 1.5s ease-out infinite;background:linear-gradient(to left, #0078D4, #D2EBFF, #0078D4);content:\"\";display:block;height:3px;left:-30%;position:relative;top:0;width:30%}._7Igxd3QGx{background-color:#F56D4F;color:var(--secondary-text)}@media screen and (-ms-high-contrast: active){._7Igxd3QGx{background-color:grayText}}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"progress-container": "_6LLM31vGx",
	"progressContainer": "_6LLM31vGx",
	"progress-bar": "_2hlz5Hwbx",
	"progressBar": "_2hlz5Hwbx",
	"progress-percent": "_70QyLkzWx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-reader-only"] + "",
	"progressPercent": "_70QyLkzWx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-reader-only"] + "",
	"fill": "_336fLpQhx",
	"filling": "X9ZXzDi5x",
	"default-fill": "_79GwA8NBx _336fLpQhx",
	"defaultFill": "_79GwA8NBx _336fLpQhx",
	"indeterminate-fill": "_7CX1GNnmx _336fLpQhx",
	"indeterminateFill": "_7CX1GNnmx _336fLpQhx",
	"indeterminate-animation": "_7ahjos0Ux",
	"indeterminateAnimation": "_7ahjos0Ux",
	"error-fill": "_7Igxd3QGx _336fLpQhx",
	"errorFill": "_7Igxd3QGx _336fLpQhx"
};
module.exports = exports;
